export const LISTING_RESULTS_GRID_CLASS =
    'listing__results-grid flex flex-wrap items-stretch gap-20';
export const LISTING_PRODUCT_WRAPPER_CLASS =
    'w-full sm:w-[calc((100%-20px)/2)] lg:w-[calc((100%-40px)/3)]';
